
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["f2m-car-logo",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 56 56"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","fill":"#fff","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M15.961 48.643c-.455 0-.914-.134-1.323-.382-9.8-6.184-13.76-18.482-9.422-29.225C9.557 8.293 20.946 2.176 32.3 4.504a2.473 2.473 0 011.927 2.922 2.461 2.461 0 01-2.915 1.913c-9.017-1.85-18.06 3.017-21.506 11.544-3.447 8.524-.3 18.283 7.473 23.203a2.459 2.459 0 01.776 3.404 2.505 2.505 0 01-2.094 1.153zM27.523 51.989c-1.59 0-3.213-.161-4.836-.503-1.337-.274-2.2-1.578-1.925-2.901a2.48 2.48 0 012.923-1.934c9.017 1.844 18.06-2.996 21.497-11.527 3.458-8.541.31-18.301-7.463-23.2a2.45 2.45 0 01-.766-3.41 2.449 2.449 0 013.397-.765 23.93 23.93 0 019.432 29.227c-3.73 9.208-12.638 15.013-22.259 15.013z"}}),_c('path',{attrs:{"d":"M35.718 39.822c-.685 0-1.367-.28-1.856-.83a2.45 2.45 0 01.224-3.481 9.967 9.967 0 002.61-11.418 9.97 9.97 0 00-10.044-6.03 2.46 2.46 0 01-2.669-2.243 2.476 2.476 0 012.256-2.685 14.922 14.922 0 0115.013 9.038 14.868 14.868 0 01-3.904 17.042 2.415 2.415 0 01-1.63.607zM27.483 42.908a14.92 14.92 0 01-13.739-9.07 14.857 14.857 0 013.904-17.044 2.461 2.461 0 013.486.225 2.46 2.46 0 01-.223 3.48c-3.256 2.858-4.305 7.43-2.61 11.398a9.986 9.986 0 0010.032 6.046c1.378-.134 2.557.889 2.68 2.247a2.468 2.468 0 01-2.256 2.664c-.43.043-.858.054-1.274.054z"}})])])
          )
        }
      }
    